import { render } from "./dashboardMeLayout.vue?vue&type=template&id=45ff845c&scoped=true&ts=true&lang=pug"
import script from "./dashboardMeLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./dashboardMeLayout.vue?vue&type=script&lang=ts&setup=true"

import "./dashboardMeLayout.vue?vue&type=style&index=0&id=45ff845c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ff845c"]])

export default __exports__